import { getApiUrl } from '@/config/api';
import type {
  PublicGeoContext,
  PublicGeoContextResponse,
  PublicPlan,
  PublicPlansResponse,
} from '@/services/api/types';

// Public, unauthenticated marketing pricing. No auth headers are sent: the
// endpoint is open and its payload is identical for every visitor (the backend
// caches it publicly), so an Admin-Console price edit propagates here within the
// server cache window. This is the single source of truth for pricing — the page
// never hardcodes prices.
export const pricingApi = {
  /** Active subscription plans for the marketing pricing page. */
  getAll: async (): Promise<PublicPlan[]> => {
    const response = await fetch(getApiUrl('public/pricing'));
    if (!response.ok) {
      throw new Error('Failed to load pricing. Please try again.');
    }
    const body = (await response.json()) as PublicPlansResponse;
    return Array.isArray(body.data) ? body.data : [];
  },

  /**
   * The viewer's display currency, resolved server-side from the request's
   * network location — the visitor never chooses one. Kept separate from
   * getAll so the plans payload stays visitor-identical and cacheable; callers
   * treat a failure as "no geo signal" and fall back to the base currency.
   */
  getGeoContext: async (): Promise<PublicGeoContext> => {
    const response = await fetch(getApiUrl('public/pricing/geo'));
    if (!response.ok) {
      throw new Error('Failed to resolve viewer pricing context.');
    }
    const body = (await response.json()) as PublicGeoContextResponse;
    return body.data;
  },
};
